import React, { useState } from 'react';
import { Box, Text, Group } from '@mantine/core';
import { useAuth } from '../hooks/useAuth';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';

const Footer = () => {
    const [loginOpened, setLoginOpened] = useState(false);
    const [dashboardOpened, setDashboardOpened] = useState(false);
    const { isAuthenticated } = useAuth();

    const handleLoginSuccess = () => {
        setLoginOpened(false);
        setDashboardOpened(true);
    };

    const handleAdminAccess = () => {
        if (isAuthenticated) {
            setDashboardOpened(true);
        } else {
            setLoginOpened(true);
        }
    };

    return (
        <footer style={{
            position: 'relative',
            padding: '2rem',
            textAlign: 'center',
            background: 'var(--header-gradient)',
            borderTop: '2px solid rgba(244, 196, 48, 0.4)',
            boxShadow: '0 -4px 15px rgba(0,0,0,0.15)'
        }}>
            {/* Jap Ji Quote */}
            <Text 
                size="xs" 
                style={{ 
                    color: 'var(--saffron-medium)', 
                    fontStyle: 'italic',
                    lineHeight: 1.4,
                    maxWidth: '600px',
                    margin: '0 auto'
                }}
            >
                "Those who do the hard work of meditating on the Name, O Nanak, their faces radiate joy and they take their holiday, bringing with them many another!" - Jap Ji Sahib, Shalok
            </Text>

            {/* Discrete admin login - bottom left */}
            <Box
                style={{
                    position: 'absolute',
                    bottom: '8px',
                    left: '8px',
                    cursor: 'pointer',
                    opacity: 0.3,
                    transition: 'opacity 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                onMouseLeave={(e) => e.target.style.opacity = '0.3'}
                onClick={handleAdminAccess}
            >
                <Text size="xs" c="dimmed">•</Text>
            </Box>

            <AdminLogin
                opened={loginOpened}
                onClose={() => setLoginOpened(false)}
                onLoginSuccess={handleLoginSuccess}
            />

            <AdminDashboard
                opened={dashboardOpened}
                onClose={() => setDashboardOpened(false)}
            />
        </footer>
    );
};

export default Footer;